import { render } from 'preact';
import './styles/tokens.css';
import './styles/base.css';
import { SessionProvider } from './session/session.jsx';
import { App } from './app.jsx';

render(
  <SessionProvider>
    <App />
  </SessionProvider>,
  document.getElementById('app'),
);
